import { useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import {
    GetViewPreferenceForView,
    SetViewPreferenceForView,
} from "../../../../utils/preferences";
import { useFetchSmsListQuery } from "../../api-hooks/smsCampaignQuery";
import SmsCampaignListView from "./SmsCampaignListView";

export default function Index() {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));

    const queryData = useFetchSmsListQuery();

    const [preferDesktop, setPreferDesktop] = useState(
        GetViewPreferenceForView("campaigns") ?? false
    );

    const preferDesktopChange = (preferDesktop: boolean) => {
        SetViewPreferenceForView("campaigns", preferDesktop);
        setPreferDesktop(preferDesktop);
    };

    return (
        <SmsCampaignListView
            isLargeScreen={isLargeScreen}
            preferDesktop={preferDesktop}
            preferDesktopChange={preferDesktopChange}
            queryData={queryData}
        />
    );
}
